'use client';

import React from "react";
import PropTypes from 'prop-types';

import {Grid} from "@mui/material";
import Divider from "@mui/material/Divider";
import Container from "@mui/material/Container";

import RecipeHead from "./recipe-head";
import RecipeSteps from "./recipe-steps";
import RecipeReview from "./recipe-review";
import RecipeGallery from "./recipe-gallery";
import RecipeOverview from "./recipe-overview";
import RecipeComments from "./recipe-comments";
import RecipeEquipmentList from "./recipe-equipment-list";
import RecipeIngredientList from "./recipe-ingredient-list";
import RecipeShortDescription from "./recipe-short-description";

function RecipeDetails({recipeData}) {

  return (
    <Container>
      <RecipeGallery recipeData={recipeData}/>
      <RecipeHead recipeData={recipeData}/>
      <Divider sx={{borderStyle: 'dashed', my: 5}}/>
      <Grid container>
        <Grid xs={12} sm={6} md={7} lg={8} sx={{mb: {xs: 2, sm: 0}}}>
          <RecipeOverview recipeData={recipeData}/>
        </Grid>
        <Grid xs={12} sm={6} md={5} lg={4}>
          <RecipeReview recipeData={recipeData}/>
        </Grid>
      </Grid>
      <Divider sx={{borderStyle: 'dashed', my: 5}}/>
      <RecipeShortDescription recipeData={recipeData}/>
      <Divider sx={{my: 2, borderStyle: 'none'}}/>
      <RecipeIngredientList recipeData={recipeData}/>
      <Divider sx={{my: 2, borderStyle: 'none'}}/>
      <RecipeEquipmentList recipeData={recipeData}/>
      <Divider sx={{my: 2, borderStyle: 'none'}}/>
      <RecipeSteps recipeData={recipeData}/>
      <Divider sx={{my: 2}}/>
      <RecipeComments recipeData={recipeData}/>
    </Container>
  )
}

RecipeDetails.propTypes = {
  recipeData: PropTypes.object,
};

export default RecipeDetails;
